// import MainHeader from '@/components/shared/MainHeader.vue';
//import testsass from '@/components/shared/testsass.vue';
import { defineAsyncComponent } from 'vue';

export default defineNuxtPlugin((app) => {
  app.vueApp.component(
    'mcp-link',
    defineAsyncComponent(() => import('@/components/shared/MCPLink.vue')),
  );
  app.vueApp.component(
    'purchase-music',
    defineAsyncComponent(() => import('@/components/shared/PurchaseMusic.vue')),
  );
  app.vueApp.component(
    'combined-section',
    defineAsyncComponent(
      () => import('@/components/shared/CombinedSection.vue'),
    ),
  );
  app.vueApp.component(
    'carousel-column-list',
    defineAsyncComponent(
      () => import('~/components/shared/carouselColumnList.vue'),
    ),
  );
  app.vueApp.component(
    'monsooq-accordion',
    defineAsyncComponent(
      () => import('@/components/shared/MonsooqAccordion.vue'),
    ),
  );
  app.vueApp.component(
    'app-benefit',
    defineAsyncComponent(() => import('@/components/shared/AppBenefit.vue')),
  );
  app.vueApp.component(
    'Accordion',
    defineAsyncComponent(() => import('@/components/shared/Accordion.vue')),
  );
  app.vueApp.component(
    'highlight-section',
    defineAsyncComponent(
      () => import('@/components/shared/HighlightSection.vue'),
    ),
  );
  app.vueApp.component(
    'FaqSection',
    defineAsyncComponent(() => import('@/components/shared/FaqSection.vue')),
  );
  app.vueApp.component(
    'get-started',
    defineAsyncComponent(() => import('@/components/shared/GetStarted.vue')),
  );
  app.vueApp.component(
    'PromoComponent',
    defineAsyncComponent(
      () => import('@/components/shared/PromoComponent.vue'),
    ),
  );
  app.vueApp.component(
    'subscription-promo',
    defineAsyncComponent(
      () => import('@/components/shared/SubscriptionPromo.vue'),
    ),
  );
  app.vueApp.component(
    'subscription-promo-head',
    defineAsyncComponent(
      () => import('@/components/shared/SubscriptionPromoHead.vue'),
    ),
  );
  app.vueApp.component(
    'subscription-promo-bottom',
    defineAsyncComponent(
      () => import('@/components/shared/SubscriptionPromoBottom.vue'),
    ),
  );
  app.vueApp.component(
    'Grid',
    defineAsyncComponent(() => import('@/components/shared/grid.vue')),
  );
  app.vueApp.component(
    'grid-dynamic',
    defineAsyncComponent(() => import('@/components/shared/grid-dynamic.vue')),
  );
  app.vueApp.component(
    'list-container',
    defineAsyncComponent(() => import('@/components/shared/ListContainer.vue')),
  );
  app.vueApp.component(
    'Tabs',
    defineAsyncComponent(() => import('@/components/shared/Tabs.vue')),
  );
  app.vueApp.component(
    'tabs-minimal',
    defineAsyncComponent(() => import('@/components/shared/TabsMinimal.vue')),
  );
  app.vueApp.component(
    'HeroHeadTitle',
    defineAsyncComponent(() => import('@/components/shared/HeroHeadTitle.vue')),
  );
  app.vueApp.component(
    'MonsooqHeroHeadTitle',
    defineAsyncComponent(
      () => import('@/components/shared/MonsooqHeroHeadTitle.vue'),
    ),
  );
  app.vueApp.component(
    'ArticleHeroHeadTitle',
    defineAsyncComponent(
      () => import('@/components/shared/ArticleHeroHeadTitle.vue'),
    ),
  );
  app.vueApp.component(
    'ViewMore',
    defineAsyncComponent(() => import('@/components/shared/ViewMore.vue')),
  );
  app.vueApp.component(
    'ViewMoreAdvance',
    defineAsyncComponent(
      () => import('@/components/shared/ViewMoreAdvance.vue'),
    ),
  );
  app.vueApp.component(
    'VideoCard',
    defineAsyncComponent(() => import('@/components/cards/VideoCard.vue')),
  );
  app.vueApp.component(
    'MusicTrack',
    defineAsyncComponent(() => import('@/components/shared/MusicTrack.vue')),
  );
  app.vueApp.component(
    'AlbumCard',
    defineAsyncComponent(() => import('@/components/cards/AlbumCard.vue')),
  );
  app.vueApp.component(
    'artist-card',
    defineAsyncComponent(() => import('@/components/cards/ArtistCard.vue')),
  );
  app.vueApp.component(
    'PlaylistCard',
    defineAsyncComponent(() => import('@/components/cards/PlaylistCard.vue')),
  );
  app.vueApp.component(
    'GameCardOnline',
    defineAsyncComponent(() => import('@/components/cards/GameCardOnline.vue')),
  );
  app.vueApp.component(
    'GameCardDownloadable',
    defineAsyncComponent(
      () => import('@/components/cards/GameCardDownloadable.vue'),
    ),
  );
  app.vueApp.component(
    'stories-card',
    defineAsyncComponent(() => import('@/components/cards/StoriesCard.vue')),
  );
  app.vueApp.component(
    'search-wrapper',
    defineAsyncComponent(() => import('@/components/search/SearchWrapper.vue')),
  );
  app.vueApp.component(
    'no-search-result',
    defineAsyncComponent(
      () => import('@/components/search/NoSearchResults.vue'),
    ),
  );
  app.vueApp.component(
    'desktop-not-supported',
    defineAsyncComponent(
      () => import('@/components/shared/DesktopNotSupported.vue'),
    ),
  );
  app.vueApp.component(
    'favorites-wrapper',
    defineAsyncComponent(
      () => import('@/components/favorites/FavoritesWrapper.vue'),
    ),
  );
  app.vueApp.component(
    'no-results',
    defineAsyncComponent(() => import('@/components/shared/NoResults.vue')),
  );
  app.vueApp.component(
    'no-favorites-result',
    defineAsyncComponent(
      () => import('@/components/shared/NoFavoritesResults.vue'),
    ),
  );
  app.vueApp.component(
    'no-purchases-result',
    defineAsyncComponent(
      () => import('@/components/shared/noPurchasesResults.vue'),
    ),
  );
  app.vueApp.component(
    'items-list-handler',
    defineAsyncComponent(
      () => import('@/components/shared/ItemsListHandler-s.vue'),
    ),
  );
  app.vueApp.component(
    'Price',
    defineAsyncComponent(() => import('@/components/shared/Price.vue')),
  );
  // list should be handled like carousel
  app.vueApp.component(
    'list',
    defineAsyncComponent(() => import('@/components/shared/Carousel-s.vue')),
  );
  app.vueApp.component(
    'carousel',
    defineAsyncComponent(() => import('@/components/shared/Carousel-s.vue')),
  );
  app.vueApp.component(
    'banner-carousel',
    defineAsyncComponent(
      () => import('@/components/shared/BannerCarousel-s.vue'),
    ),
  );
  app.vueApp.component(
    'product-card',
    defineAsyncComponent(
      () => import('@/components/monsooq/cards/ProductCard.vue'),
    ),
  );
  app.vueApp.component(
    'view-all-grid',
    defineAsyncComponent(() => import('@/components/shared/ViewAllGrid.vue')),
  );
  app.vueApp.component(
    'preview-carousel',
    defineAsyncComponent(
      () => import('@/components/shared/PreviewCarousel-s.vue'),
    ),
  );
  app.vueApp.component(
    'block-busters-carousel',
    defineAsyncComponent(
      () => import('@/components/shared/BlockBustersCarousel.vue'),
    ),
  );
  app.vueApp.component(
    'block-busters-card',
    defineAsyncComponent(
      () => import('@/components/cards/BlockBustersCard.vue'),
    ),
  );
  app.vueApp.component(
    'hero-banner-monsooq-carousel',
    defineAsyncComponent(
      () => import('@/components/shared/HeroBannerMonsooqCarousel.vue'),
    ),
  );
  app.vueApp.component(
    'music-track-thumbnail',
    defineAsyncComponent(
      () => import('@/components/cards/MusicTrackThumbnail.vue'),
    ),
  );
  app.vueApp.component(
    'GenreCard',
    defineAsyncComponent(() => import('@/components/cards/GenreCard.vue')),
  );
  app.vueApp.component(
    'MoodCard',
    defineAsyncComponent(() => import('@/components/cards/MoodCard.vue')),
  );
  app.vueApp.component(
    'ImageCard',
    defineAsyncComponent(() => import('@/components/cards/ImageCard.vue')),
  );
  app.vueApp.component(
    'club-card',
    defineAsyncComponent(() => import('@/components/cards/ClubCard.vue')),
  );
  app.vueApp.component(
    'promo-club-card',
    defineAsyncComponent(() => import('@/components/cards/PromoClubCard.vue')),
  );
  app.vueApp.component(
    'scope-card',
    defineAsyncComponent(() => import('@/components/cards/ScopeCard.vue')),
  );
  app.vueApp.component(
    'scope-card-horizontal',
    defineAsyncComponent(
      () => import('@/components/cards/ScopeCardHorizontal.vue'),
    ),
  );
  app.vueApp.component(
    'monsooq-info-banner',
    defineAsyncComponent(
      () => import('@/components/shared/MonsooqInfoBanner.vue'),
    ),
  );
  app.vueApp.component(
    'app-info-banner',
    defineAsyncComponent(() => import('@/components/cards/AppInfoBanner.vue')),
  );
  app.vueApp.component(
    'monsooq-info-card',
    defineAsyncComponent(
      () => import('@/components/shared/MonsooqInfoCard.vue'),
    ),
  );
  app.vueApp.component(
    'hero-meta-data-app',
    defineAsyncComponent(
      () => import('@/components/shared/HeroMetaDataApp.vue'),
    ),
  );
  app.vueApp.component(
    'tournament-card',
    defineAsyncComponent(
      () => import('@/components/tournaments/TournamentCard.vue'),
    ),
  );
  app.vueApp.component(
    'hero-tournament-banner-slide',
    defineAsyncComponent(
      () => import('@/components/tournaments/HeroTournamentBannerSlide.vue'),
    ),
  );
  app.vueApp.component(
    'subscription-partner-card',
    defineAsyncComponent(
      () => import('@/components/cards/SubscriptionPartnerCard.vue'),
    ),
  );
  app.vueApp.component(
    'mini-club-card',
    defineAsyncComponent(() => import('@/components/cards/MiniClubCard.vue')),
  );
  app.vueApp.component(
    'SubscriptionCard',
    defineAsyncComponent(
      () => import('@/components/cards/SubscriptionCard.vue'),
    ),
  );
  app.vueApp.component(
    'subscription-card-package',
    defineAsyncComponent(
      () => import('@/components/cards/SubscriptionCardPackage.vue'),
    ),
  );
  app.vueApp.component(
    'subscription-card-decide',
    defineAsyncComponent(
      () => import('@/components/cards/SubscriptionCardDecide.vue'),
    ),
  );
  app.vueApp.component(
    'subscription-plan-card',
    defineAsyncComponent(
      () => import('@/components/cards/SubscriptionPlanCard.vue'),
    ),
  );
  app.vueApp.component(
    'subscription-plan-card-custom',
    defineAsyncComponent(
      () => import('@/components/cards/SubscriptionPlanCardCustom.vue'),
    ),
  );
  app.vueApp.component(
    'subscription-carousel',
    defineAsyncComponent(
      () => import('@/components/shared/SubscriptionCarousel.vue'),
    ),
  );
  app.vueApp.component(
    'subscription-grid',
    defineAsyncComponent(
      () => import('@/components/shared/SubscriptionGrid.vue'),
    ),
  );
  app.vueApp.component(
    'device-not-supported',
    defineAsyncComponent(
      () => import('@/components/shared/DeviceNotSupported.vue'),
    ),
  );
  app.vueApp.component(
    'horizontal-game-card',
    defineAsyncComponent(
      () => import('@/components/shared/horizontalGameCard.vue'),
    ),
  );
  app.vueApp.component(
    'CategoryCard',
    defineAsyncComponent(() => import('@/components/cards/CategoryCard.vue')),
  );
  app.vueApp.component(
    'TopItemList',
    defineAsyncComponent(() => import('@/components/shared/TopItemList.vue')),
  );
  app.vueApp.component(
    'HeroBannerWrapper',
    defineAsyncComponent(
      () => import('@/components/shared/HeroBannerWrapper.vue'),
    ),
  );
  app.vueApp.component(
    'hero-banner-carousel',
    defineAsyncComponent(
      () => import('@/components/shared/HeroBannerCarousel.vue'),
    ),
  );
  app.vueApp.component(
    'competition-banner-carousel',
    defineAsyncComponent(
      () => import('@/components/shared/CompetitionBannerCarousel.vue'),
    ),
  );
  app.vueApp.component(
    'competition-banner',
    defineAsyncComponent(
      () => import('@/components/shared/CompetitionBanner.vue'),
    ),
  );

  app.vueApp.component(
    'leaderboard-dialog',
    defineAsyncComponent(
      () => import('@/components/dialogs/LeaderboardDialog.vue'),
    ),
  );

  app.vueApp.component(
    'hero-music-details-banner',
    defineAsyncComponent(
      () => import('@/components/shared/HeroMusicDetailsBanner.vue'),
    ),
  );
  app.vueApp.component(
    'hero-podcast-details-banner',
    defineAsyncComponent(
      () => import('@/components/shared/HeroPodcastDetailsBanner.vue'),
    ),
  );
  app.vueApp.component(
    'hero-meta-data-podcast',
    defineAsyncComponent(
      () => import('@/components/shared/HeroMetaDataPodcast.vue'),
    ),
  );
  app.vueApp.component(
    'hero-audiobook-details-banner',
    defineAsyncComponent(
      () => import('@/components/shared/HeroAudiobookDetailsBanner.vue'),
    ),
  );
  app.vueApp.component(
    'hero-meta-data-audiobook',
    defineAsyncComponent(
      () => import('@/components/shared/HeroMetaDataAudiobook.vue'),
    ),
  );
  app.vueApp.component(
    'hero-meta-data-album',
    defineAsyncComponent(
      () => import('@/components/shared/HeroMetaDataAlbum.vue'),
    ),
  );
  app.vueApp.component(
    'hero-banner-background',
    defineAsyncComponent(
      () => import('@/components/shared/HeroBannerBackground.vue'),
    ),
  );
  app.vueApp.component(
    'hero-meta-data-artist',
    defineAsyncComponent(
      () => import('@/components/shared/HeroMetaDataArtist.vue'),
    ),
  );
  app.vueApp.component(
    'ExternalFooter',
    defineAsyncComponent(
      () => import('@/components/shared/ExternalFooter.vue'),
    ),
  );
  app.vueApp.component(
    'hero-meta-data-track',
    defineAsyncComponent(
      () => import('@/components/shared/HeroMetaDataTrack.vue'),
    ),
  );
  app.vueApp.component(
    'HeroMetaDataAudiobookGenre',
    defineAsyncComponent(
      () => import('@/components/shared/HeroMetaDataGenre.vue'),
    ),
  );
  app.vueApp.component(
    'hero-game-details-banner',
    defineAsyncComponent(
      () => import('@/components/shared/HeroGameDetailsBanner.vue'),
    ),
  );
  app.vueApp.component(
    'series-wrapper',
    defineAsyncComponent(() => import('@/components/series/SeriesWrapper.vue')),
  );
  app.vueApp.component(
    'session-expired',
    defineAsyncComponent(
      () => import('@/components/dialogs/SessionExpired.vue'),
    ),
  );
  app.vueApp.component(
    'free-trial-subscription',
    defineAsyncComponent(
      () => import('@/components/dialogs/FreeTrialSubscription.vue'),
    ),
  );
  app.vueApp.component(
    'free-access-dialog',
    defineAsyncComponent(
      () => import('../components/dialogs/FreeAccessDialog.vue'),
    ),
  );
  app.vueApp.component(
    'arcade-free-play',
    defineAsyncComponent(
      () => import('../components/dialogs/ArcadeFreePlay.vue'),
    ),
  );
  app.vueApp.component(
    'confirmation-dialog',
    defineAsyncComponent(
      () => import('@/components/dialogs/ConfirmationDialog.vue'),
    ),
  );
  app.vueApp.component(
    'redeem-dialog',
    defineAsyncComponent(() => import('@/components/dialogs/RedeemDialog.vue')),
  );
  app.vueApp.component(
    'CustomSubscriptionDialog',
    defineAsyncComponent(
      () => import('@/components/dialogs/CustomSubscriptionDialog.vue'),
    ),
  );
  app.vueApp.component(
    'challenge-dialog',
    defineAsyncComponent(
      () => import('@/components/dialogs/ChallengeDialog.vue'),
    ),
  );
  app.vueApp.component(
    'douple-optIn-with-consent',
    defineAsyncComponent(
      () => import('@/components/dialogs/DoupleOptInWithConsent.vue'),
    ),
  );
  app.vueApp.component(
    'rating-dialog',
    defineAsyncComponent(() => import('@/components/dialogs/RatingDialog.vue')),
  );
  app.vueApp.component(
    'join-challenge-dialog',
    defineAsyncComponent(
      () => import('@/components/dialogs/JoinChallengeDialog.vue'),
    ),
  );
  app.vueApp.component(
    'episodes-list',
    defineAsyncComponent(() => import('@/components/cards/episodesList.vue')),
  );
  app.vueApp.component(
    'wow-episodes-grid',
    defineAsyncComponent(
      () => import('@/components/video/grid/WowEpisodeGrid.vue'),
    ),
  );
  app.vueApp.component(
    'genre-games',
    defineAsyncComponent(() => import('@/components/cards/GenreGames.vue')),
  );
  app.vueApp.component(
    'SubscribeDecide',
    defineAsyncComponent(
      () => import('@/components/dialogs/SubscribeDecide.vue'),
    ),
  );
  app.vueApp.component(
    'LoginPopUp',
    defineAsyncComponent(() => import('@/components/dialogs/LoginPopUp.vue')),
  );
  app.vueApp.component(
    'Stories',
    defineAsyncComponent(() => import('@/components/dialogs/Stories.vue')),
  );
  app.vueApp.component(
    'DeviceNotSupportedDialog',
    defineAsyncComponent(
      () => import('@/components/dialogs/DeviceNotSupported.vue'),
    ),
  );
  app.vueApp.component(
    'LoginNotSupportedByWifiDialog',
    defineAsyncComponent(
      () => import('@/components/dialogs/LoginNotSupportedByWifi.vue'),
    ),
  );
  app.vueApp.component(
    'page-title',
    defineAsyncComponent(() => import('@/components/shared/pageTitle.vue')),
  );
    app.vueApp.component(
    'PartnerRegistration',
    defineAsyncComponent(() => import('@/components/shared/PartnerRegistration.vue')),
  );
  app.vueApp.component(
    'game-mixed-card',
    defineAsyncComponent(() => import('@/components/cards/GameMixedCard.vue')),
  );
  app.vueApp.component(
    'recent-game-card',
    defineAsyncComponent(
      () => import('@/components/shared/RecentGameCard.vue'),
    ),
  );
  app.vueApp.component(
    'history-wrapper',
    defineAsyncComponent(
      () => import('@/components/myHistory/MyHistoryWrapper.vue'),
    ),
  );
  app.vueApp.component(
    'no-history-result',
    defineAsyncComponent(
      () => import('@/components/shared/NoHistoryResults.vue'),
    ),
  );
  app.vueApp.component(
    'Dynamic-structure',
    defineAsyncComponent(
      () => import('@/components/shared/DynamicStructure.vue'),
    ),
  );
  app.vueApp.component(
    'user-login',
    defineAsyncComponent(() => import('@/components/login/userLogin.vue')),
  );
  app.vueApp.component(
    'app-download-banner',
    defineAsyncComponent(
      () => import('@/components/AppDownloadBanner/AppDownloadBanner.vue'),
    ),
  );

  app.vueApp.component(
    'Player',
    // defineAsyncComponent(
    //   () => import('@/components/video-player/EmptyPlayer.vue'),
    // ),
    defineAsyncComponent(() => import('@/components/video-player/Player.vue')),
  );
  app.vueApp.component(
    'Share',
    defineAsyncComponent(() => import('@/components/dialogs/Share.vue')),
  );
  app.vueApp.component(
    'ShareGamePopup',
    defineAsyncComponent(() => import('@/components/dialogs/ShareGamePopup.vue')),
  );
  app.vueApp.component(
    'GameTrailer',
    defineAsyncComponent(() => import('@/components/dialogs/GameTrailer.vue')),
  );
  app.vueApp.component(
    'Subscribe',
    defineAsyncComponent(() => import('@/components/dialogs/Subscribe.vue')),
  );
  app.vueApp.component(
    'ConfirmPurchaseDialog',
    defineAsyncComponent(
      () => import('@/components/dialogs/ConfirmPurchase.vue'),
    ),
  );
  app.vueApp.component(
    'SinglePurchaseConfirm',
    defineAsyncComponent(
      () => import('@/components/dialogs/SinglePurchaseConfirm.vue'),
    ),
  );
  app.vueApp.component(
    'SubscriptionFeedback',
    defineAsyncComponent(
      () => import('@/components/dialogs/SubscriptionFeedback.vue'),
    ),
  );
  app.vueApp.component(
    'SubscriptionFeedbackV2',
    defineAsyncComponent(
      () => import('@/components/dialogs/SubscriptionFeedbackV2.vue'),
    ),
  );
  app.vueApp.component(
    'feedback-pop-up',
    defineAsyncComponent(
      () => import('@/components/dialogs/feedbackPopUp.vue'),
    ),
  );
  app.vueApp.component(
    'GalleryCarousel',
    defineAsyncComponent(
      () => import('@/components/dialogs/GalleryCarousel.vue'),
    ),
  );
  app.vueApp.component(
    'end-flow-subscription-dialog',
    defineAsyncComponent(
      () => import('@/components/dialogs/EndFlowSubscriptionDialog.vue'),
    ),
  );
  app.vueApp.component(
    'end-subscription-flow-with-redirect',
    defineAsyncComponent(
      () => import('@/components/dialogs/EndSubscriptionFlowWithRedirect.vue'),
    ),
  );
  app.vueApp.component(
    'MusicQueue',
    defineAsyncComponent(
      () => import('@/components/music-player/MusicQueue.vue'),
    ),
  );
  app.vueApp.component(
    'DraggableSongList',
    defineAsyncComponent(
      () => import('@/components/music-player/DraggableSongList.vue'),
    ),
  );
  app.vueApp.component(
    'AppbarUserMenu',
    defineAsyncComponent(
      () => import('@/components/shared/AppbarUserMenu.vue'),
    ),
  );
  app.vueApp.component(
    'MainHeader',
    defineAsyncComponent(() => import('@/components/shared/MainHeader.vue')),
  );
  app.vueApp.component(
    'MonsooqMainHeader',
    defineAsyncComponent(
      () => import('@/components/shared/MonsooqMainHeader.vue'),
    ),
  );
  app.vueApp.component(
    'MiniPlayer',
    defineAsyncComponent(
      () => import('@/components/music-player/MiniPlayer.vue'),
    ),
  );
  app.vueApp.component(
    'MusicFullPlayer',
    defineAsyncComponent(
      () => import('@/components/music-player/MusicFullPlayer.vue'),
    ),
  );
  app.vueApp.component(
    'Snackbar',
    defineAsyncComponent(() => import('@/components/shared/Snackbar.vue')),
  );
  app.vueApp.component(
    'SkipLink',
    defineAsyncComponent(() => import('@/components/shared/SkipLink.vue')),
  );
  app.vueApp.component(
    'SkipToPlayer',
    defineAsyncComponent(() => import('@/components/shared/SkipToPlayer.vue')),
  );
  app.vueApp.component(
    'FilterByVideoTrailer',
    defineAsyncComponent(
      () => import('@/components/shared/FilterByVideoTrailer.vue'),
    ),
  );
  app.vueApp.component(
    'CardTrailer',
    defineAsyncComponent(() => import('@/components/cards/CardTrailer.vue')),
  );

  app.vueApp.component(
    'user-data',
    defineAsyncComponent(() => import('@/components/profile/userData.vue')),
  );
  app.vueApp.component(
    'user-subscription',
    defineAsyncComponent(
      () => import('@/components/profile/userSubscription.vue'),
    ),
  );
  app.vueApp.component(
    'profile-list',
    defineAsyncComponent(() => import('@/components/profile/ProfileList.vue')),
  );
  app.vueApp.component(
    'club-promotional-card',
    defineAsyncComponent(
      () => import('@/components/cards/ClubPromotionalCard.vue'),
    ),
  );

  app.vueApp.component(
    'Dialogs',
    defineAsyncComponent(() => import('@/components/dialogs/Dialogs.vue')),
  );
  app.vueApp.component(
    'MainFooter',
    defineAsyncComponent(() => import('@/components/shared/MainFooter.vue')),
  );
  app.vueApp.component(
    'Disclaimer',
    defineAsyncComponent(() => import('@/components/shared/Disclaimer.vue')),
  );
  app.vueApp.component(
    'HeroMetaDataGenre',
    defineAsyncComponent(
      () => import('@/components/shared/HeroMetaDataGenre.vue'),
    ),
  );
  app.vueApp.component(
    'hero-video-banner-slide',
    defineAsyncComponent(
      () => import('@/components/shared/HeroVideoBannerSlide.vue'),
    ),
  );
  app.vueApp.component(
    'hero-game-banner-slide',
    defineAsyncComponent(
      () => import('@/components/shared/HeroGameBannerSlide.vue'),
    ),
  );
  app.vueApp.component(
    'hero-monsooq-banner-slide',
    defineAsyncComponent(
      () => import('@/components/shared/HeroMonsooqBannerSlide.vue'),
    ),
  );
  app.vueApp.component(
    'hero-banner-voucher-slider',
    defineAsyncComponent(
      () => import('@/components/shared/HeroBannerVoucherSlider.vue'),
    ),
  );
  app.vueApp.component(
    'hero-monsooq-banner',
    defineAsyncComponent(
      () => import('@/components/shared/HeroMonsooqBanner.vue'),
    ),
  );
  app.vueApp.component(
    'hero-music-banner-slide',
    defineAsyncComponent(
      () => import('@/components/shared/HeroMusicBannerSlide.vue'),
    ),
  );
  app.vueApp.component(
    'hero-video-details-banner',
    defineAsyncComponent(
      () => import('@/components/shared/HeroVideoDetailsBanner.vue'),
    ),
  );
  app.vueApp.component(
    'hero-ex-video-details-banner',
    defineAsyncComponent(
      () =>
        import('@/components/external-provider/HeroExVideoDetailsBanner.vue'),
    ),
  );
  app.vueApp.component(
    'background-banner',
    defineAsyncComponent(
      () => import('@/components/shared/BackgroundBanner.vue'),
    ),
  );
  app.vueApp.component(
    'video-list-carousel',
    defineAsyncComponent(
      () => import('@/components/shared/VideoListCarousel.vue'),
    ),
  );
  app.vueApp.component(
    'miniclub-subscription-card',
    defineAsyncComponent(
      () => import('@/components/cards/MiniClubSubscriptionCard.vue'),
    ),
  );
  app.vueApp.component(
    'subscription-popup',
    defineAsyncComponent(
      () => import('@/components/dialogs/SubscriptionPopUp.vue'),
    ),
  );
  app.vueApp.component(
    'subscription-popup-v2',
    defineAsyncComponent(
      () => import('@/components/dialogs/SubscriptionPopUpV2.vue'),
    ),
  );
  app.vueApp.component(
    'subscription-popup-v3',
    defineAsyncComponent(
      () => import('@/components/dialogs/SubscriptionPopUpV3.vue'),
    ),
  );
  app.vueApp.component(
    'subscription-pop-groups',
    defineAsyncComponent(
      () => import('@/components/dialogs/SubscriptionPopWithGroups.vue'),
    ),
  );
  app.vueApp.component(
    'purchase-popup',
    defineAsyncComponent(
      () => import('@/components/dialogs/purchasePopup.vue'),
    ),
  );
  app.vueApp.component(
    'purchase-result-popup',
    defineAsyncComponent(
      () => import('@/components/dialogs/purchaseResultPopup.vue'),
    ),
  );
  app.vueApp.component(
    'loading-popup',
    defineAsyncComponent(
      () => import('@/components/dialogs/loadingDialog.vue'),
    ),
  );

  app.vueApp.component(
    'text-popup',
    defineAsyncComponent(
      () => import('@/components/dialogs/DialogWithText.vue'),
    ),
  );
  app.vueApp.component(
    'credit-expiration',
    defineAsyncComponent(
      () => import('@/components/dialogs/CreditExpiration.vue'),
    ),
  );
  app.vueApp.component(
    'subscription-custom-plan',
    defineAsyncComponent(
      () => import('@/components/subscriptions/SubscriptionCustomPlan.vue'),
    ),
  );
  app.vueApp.component(
    'SubscriptionPlan',
    defineAsyncComponent(
      () => import('@/components/subscriptions/SubscriptionPlan.vue'),
    ),
  );
  app.vueApp.component(
    'SubscriptionTypesCalculator',
    defineAsyncComponent(
      () =>
        import('@/components/subscriptions/SubscriptionTypesCalculator.vue'),
    ),
  );
  app.vueApp.component(
    'partners-card',
    defineAsyncComponent(() => import('@/components/cards/PartnersCard.vue')),
  );
  app.vueApp.component(
    'steps-card',
    defineAsyncComponent(() => import('@/components/cards/StepsCard.vue')),
  );
  app.vueApp.component(
    'cart-price-card',
    defineAsyncComponent(
      () => import('@/components/vouchers/CartPriceCard.vue'),
    ),
  );
  app.vueApp.component(
    'cart-card',
    defineAsyncComponent(() => import('@/components/vouchers/CartCard.vue')),
  );
  app.vueApp.component(
    'banner-wrapper',
    defineAsyncComponent(() => import('@/components/shared/BannerWrapper.vue')),
  );
  app.vueApp.component(
    'partners-banner',
    defineAsyncComponent(
      () => import('@/components/shared/PartnersBanner.vue'),
    ),
  );
  app.vueApp.component(
    'feature-banner',
    defineAsyncComponent(() => import('@/components/shared/FeatureBanner.vue')),
  );
  app.vueApp.component(
    'partner-subscription-details',
    defineAsyncComponent(
      () => import('@/components/shared/PartnerSubscriptionDetails.vue'),
    ),
  );
  app.vueApp.component(
    'partner-header',
    defineAsyncComponent(() => import('@/components/shared/PartnerHeader.vue')),
  );
  app.vueApp.component(
    'video-search-result',
    defineAsyncComponent(
      () => import('@/components/search/VideoSearchResult.vue'),
    ),
  );
  app.vueApp.component(
    'external-video-search-result',
    defineAsyncComponent(
      () => import('@/components/search/ExternalVideoSearchResult.vue'),
    ),
  );
  app.vueApp.component(
    'album-search-result',
    defineAsyncComponent(
      () => import('@/components/search/AlbumSearchResult.vue'),
    ),
  );
  app.vueApp.component(
    'artist-search-result',
    defineAsyncComponent(
      () => import('@/components/search/ArtistSearchResult.vue'),
    ),
  );
  app.vueApp.component(
    'game-search-result',
    defineAsyncComponent(
      () => import('@/components/search/GameSearchResult.vue'),
    ),
  );
  app.vueApp.component(
    'product-search-result',
    defineAsyncComponent(
      () => import('@/components/search/ProductSearchResult.vue'),
    ),
  );
  app.vueApp.component(
    'track-search-result',
    defineAsyncComponent(
      () => import('@/components/search/TrackSearchResult.vue'),
    ),
  );
  app.vueApp.component(
    'playlist-search-result',
    defineAsyncComponent(
      () => import('@/components/search/PlaylistSearchResult.vue'),
    ),
  );
  app.vueApp.component(
    'all-search-result',
    defineAsyncComponent(
      () => import('@/components/search/AllSearchResult.vue'),
    ),
  );
  app.vueApp.component(
    'promotional-banner',
    defineAsyncComponent(
      () => import('@/components/shared/PromotionalBanner.vue'),
    ),
  );
  app.vueApp.component(
    'inactive-subscription-dialog',
    defineAsyncComponent(
      () => import('@/components/dialogs/InActiveSubscription.vue'),
    ),
  );
  app.vueApp.component(
    'search-filter',
    defineAsyncComponent(() => import('@/components/search/SearchFilter.vue')),
  );
  app.vueApp.component(
    'animated-song',
    defineAsyncComponent(() => import('@/components/shared/AnimatedSong.vue')),
  );
  app.vueApp.component(
    'card',
    defineAsyncComponent(() => import('@/components/shared/icons/Card.vue')),
  );
  app.vueApp.component(
    'search-result-design-card',
    defineAsyncComponent(
      () => import('@/components/search/SearchResultDesignCard.vue'),
    ),
  );
  app.vueApp.component(
    'monsooq-search-result-card',
    defineAsyncComponent(
      () => import('@/components/search/MonsooqSearchResultCard.vue'),
    ),
  );
  app.vueApp.component(
    'user-subscription-card',
    defineAsyncComponent(
      () => import('@/components/cards/UserSubscriptionCard.vue'),
    ),
  );
  app.vueApp.component(
    'redeem-feedback-dialog',
    defineAsyncComponent(
      () => import('@/components/dialogs/RedeemFeedbackDialog.vue'),
    ),
  );
  app.vueApp.component(
    'PaymentWebIframe',
    defineAsyncComponent(
      () => import('@/components/dialogs/PaymentWebIframe.vue'),
    ),
  );
  app.vueApp.component(
    'navigation-bar',
    defineAsyncComponent(() => import('@/components/shared/NavigationBar.vue')),
  );
  app.vueApp.component(
    'login-subscription-error-dialog',
    defineAsyncComponent(
      () => import('@/components/dialogs/LoginSubscriptionErrorPop.vue'),
    ),
  );

  app.vueApp.component(
    'hero-game-full-screen-banner',
    defineAsyncComponent(
      () => import('@/components/shared/HeroGameFullScreenBanner.vue'),
    ),
  );

  app.vueApp.component(
    'benefit-info-card',
    defineAsyncComponent(
      () => import('@/components/shared/BenefitInfoCard.vue'),
    ),
  );

  app.vueApp.component(
    'UserOneSubscriptionCard',
    defineAsyncComponent(
      () => import('@/components/cards/UserOneSubscriptionCard.vue'),
    ),
  );

  app.vueApp.component(
    'confirm-parenta-control-pop',
    defineAsyncComponent(
      () => import('@/components/dialogs/ConfirmParentalControlPop.vue'),
    ),
  );

  app.vueApp.component(
    'confirm-reset-parental-pass-modal',
    defineAsyncComponent(
      () => import('@/components/dialogs/ConfirmResetParentalPassDialog.vue'),
    ),
  );

  app.vueApp.component(
    'trending-list',
    defineAsyncComponent(() => import('@/components/shared/TrendingList.vue')),
  );
  app.vueApp.component(
    'img-modal',
    defineAsyncComponent(() => import('@/components/dialogs/imgModal.vue')),
  );
  app.vueApp.component(
    'ads-banner',
    defineAsyncComponent(() => import('@/components/shared/AdsBanner.vue')),
  );

  app.vueApp.component(
    'podcast-card',
    defineAsyncComponent(() => import('@/components/cards/PodcastCard.vue')),
  );

  app.vueApp.component(
    'podcast-episode-card',
    defineAsyncComponent(
      () => import('@/components/cards/PodcastEpisodeCard.vue'),
    ),
  );
  app.vueApp.component(
    'podcast-list',
    defineAsyncComponent(() => import('@/components/shared/PodcastList.vue')),
  );
  app.vueApp.component(
    'audiobook-card',
    defineAsyncComponent(() => import('@/components/cards/AudiobookCard.vue')),
  );
  app.vueApp.component(
    'audiobook-chapter-card',
    defineAsyncComponent(
      () => import('@/components/cards/AudiobookChapterCard.vue'),
    ),
  );
  app.vueApp.component(
    'audiobook-list',
    defineAsyncComponent(() => import('@/components/shared/AudiobookList.vue')),
  );
  app.vueApp.component(
    'article-details',
    defineAsyncComponent(
      () => import('@/components/article/ArticleDetails.vue'),
    ),
  );
  app.vueApp.component(
    'teaser-details',
    defineAsyncComponent(
      () => import('@/components/article/TeaserDetails.vue'),
    ),
  );
  app.vueApp.component(
    'teaser-default',
    defineAsyncComponent(
      () => import('@/components/article/TeaserDefaultTemplate.vue'),
    ),
  );
  app.vueApp.component(
    'podcast-search-result',
    defineAsyncComponent(
      () => import('@/components/search/PodcastSearchResult.vue'),
    ),
  );
  app.vueApp.component(
    'episode-podcast-search-result',
    defineAsyncComponent(
      () => import('@/components/search/EpisodePodcastSearchResult.vue'),
    ),
  );
  app.vueApp.component(
    'audiobook-search-result',
    defineAsyncComponent(
      () => import('@/components/search/AudiobookSearchResult.vue'),
    ),
  );
  app.vueApp.component(
    'audiobook-chapter-search-result',
    defineAsyncComponent(
      () => import('@/components/search/AudiobookChapterSearchResult.vue'),
    ),
  );
  app.vueApp.component(
    'article-search-result',
    defineAsyncComponent(
      () => import('@/components/search/ArticleSearchResult.vue'),
    ),
  );
  app.vueApp.component(
    'article-video-search-result',
    defineAsyncComponent(
      () => import('@/components/search/ArticleVideoSearchResult.vue'),
    ),
  );

  app.vueApp.component(
    'merge-all-search-result',
    defineAsyncComponent(
      () => import('@/components/search/MergeAllSearchResult.vue'),
    ),
  );
  app.vueApp.component(
    'article-video-card',
    defineAsyncComponent(
      () => import('@/components/cards/ArticleVideoCard.vue'),
    ),
  );
  app.vueApp.component(
    'article-video-grid',
    defineAsyncComponent(
      () => import('@/components/article/ArticleVideoGrid.vue'),
    ),
  );
  app.vueApp.component(
    'article-video-widget',
    defineAsyncComponent(
      () => import('@/components/article/ArticleVideoWidget.vue'),
    ),
  );
  app.vueApp.component(
    'social-network-banner',
    defineAsyncComponent(
      () => import('@/components/shared/SocialNetworkBanner.vue'),
    ),
  );
  app.vueApp.component(
    'article-videos-list',
    defineAsyncComponent(
      () => import('@/components/article/ArticleVideosList.vue'),
    ),
  );
  app.vueApp.component(
    'article-video-card-horizontal',
    defineAsyncComponent(
      () => import('@/components/cards/ArticleVideoCardHorizontal.vue'),
    ),
  );
  app.vueApp.component(
    'external-video-card',
    defineAsyncComponent(
      () => import('@/components/external-provider/ExternalVideoCard.vue'),
    ),
  );
  app.vueApp.component(
    'VoucherCard',
    defineAsyncComponent(() => import('@/components/vouchers/VoucherCard.vue')),
  );
  app.vueApp.component(
    'voucher-book-header',
    defineAsyncComponent(
      () => import('@/components/shared/VoucherBookHeader.vue'),
    ),
  );
  app.vueApp.component(
    'voucher-book-card',
    defineAsyncComponent(
      () => import('@/components/vouchers/VoucherBookCard.vue'),
    ),
  );
  app.vueApp.component(
    'payment-options-pop',
    defineAsyncComponent(
      () => import('@/components/dialogs/PaymentOptionsPop.vue'),
    ),
  );
  app.vueApp.component(
    'one-time-payment-options-pop',
    defineAsyncComponent(
      () => import('@/components/dialogs/OneTimePaymentOptionsPop.vue'),
    ),
  );
  app.vueApp.component(
    'voucher-purchase-pop',
    defineAsyncComponent(
      () => import('@/components/dialogs/VoucherPurchasePop.vue'),
    ),
  );
  app.vueApp.component(
    'hero-ex-video-banner-slide',
    defineAsyncComponent(
      () => import('@/components/external-provider/HeroExVideoBannerSlide.vue'),
    ),
  );
  app.vueApp.component(
    'taboola-widget',
    defineAsyncComponent(
      () => import('@/components/article/TaboolaWidget.vue'),
    ),
  );
  app.vueApp.component(
    'login-header',
    defineAsyncComponent(() => import('@/components/shared/LoginHeader.vue')),
  );
  app.vueApp.component(
    'hero-podcast-slide-banner',
    defineAsyncComponent(
      () => import('@/components/shared/HeroPodcastSlideBanner.vue'),
    ),
  );
  app.vueApp.component(
    'hero-audiobook-slide-banner',
    defineAsyncComponent(
      () => import('@/components/shared/HeroAudiobookSlideBanner.vue'),
    ),
  );
  app.vueApp.component(
    'hero-voucher-details-banner',
    defineAsyncComponent(
      () => import('@/components/vouchers/HeroVoucherDetailsBanner.vue'),
    ),
  );
  app.vueApp.component(
    'voucher-options-selection',
    defineAsyncComponent(
      () => import('@/components/vouchers/VoucherOptionsSelection.vue'),
    ),
  );
  app.vueApp.component(
    'voucher-platform-selection',
    defineAsyncComponent(
      () => import('@/components/vouchers/VoucherPlatformSelection.vue'),
    ),
  );
  app.vueApp.component(
    'voucher-gallery',
    defineAsyncComponent(
      () => import('@/components/vouchers/VoucherGallery.vue'),
    ),
  );
  app.vueApp.component(
    'voucher-info',
    defineAsyncComponent(() => import('@/components/vouchers/VoucherInfo.vue')),
  );
  app.vueApp.component(
    'no-vouchers',
    defineAsyncComponent(() => import('@/components/vouchers/NoVouchers.vue')),
  );
  app.vueApp.component(
    'voucher-item',
    defineAsyncComponent(() => import('@/components/vouchers/VoucherItem.vue')),
  );
  app.vueApp.component(
    'tournament-participants',
    defineAsyncComponent(
      () => import('@/components/tournaments/TournamentParticipants.vue'),
    ),
  );
  app.vueApp.component(
    'hero-tournament-details-banner',
    defineAsyncComponent(
      () => import('@/components/tournaments/HeroTournamentDetailsBanner.vue'),
    ),
  );
  app.vueApp.component(
    'tournament-overview',
    defineAsyncComponent(
      () => import('@/components/tournaments/TournamentOverview.vue'),
    ),
  );
  app.vueApp.component(
    'tournament-rules',
    defineAsyncComponent(
      () => import('@/components/tournaments/TournamentRules.vue'),
    ),
  );
  app.vueApp.component(
    'tournament-gallery-carousel',
    defineAsyncComponent(
      () => import('@/components/tournaments/TournamentGalleryCarousel.vue'),
    ),
  );
  app.vueApp.component(
    'tournament-prizes',
    defineAsyncComponent(
      () => import('@/components/tournaments/TournamentPrizes.vue'),
    ),
  );
  app.vueApp.component(
    'tournament-video-details',
    defineAsyncComponent(
      () => import('@/components/tournaments/TournamentVideoDetails.vue'),
    ),
  );
  app.vueApp.component(
    'hero-voucher-banner-slide',
    defineAsyncComponent(
      () => import('@/components/vouchers/HeroVoucherBannerSlide.vue'),
    ),
  );
  app.vueApp.component(
    'voucher-category-card',
    defineAsyncComponent(
      () => import('@/components/vouchers/VoucherCategoryCard.vue'),
    ),
  );
  app.vueApp.component(
    'hero-dynamic-banner-slide',
    defineAsyncComponent(
      () => import('@/components/shared/HeroDynamicBannerSlide.vue'),
    ),
  );
  app.vueApp.component(
    'voucher-price',
    defineAsyncComponent(
      () => import('@/components/vouchers/VoucherPrice.vue'),
    ),
  );
  app.vueApp.component(
    'join-tournament-dialog',
    defineAsyncComponent(
      () => import('@/components/dialogs/JoinTournamentDialog.vue'),
    ),
  );
  app.vueApp.component(
    'notifications-center',
    defineAsyncComponent(
      () => import('@/components/notifications/NotificationsCenter.vue'),
    ),
  );

  app.vueApp.component(
    'tournament-leaderboards',
    defineAsyncComponent(
      () => import('@/components/tournaments/TournamentLeaderboards.vue'),
    ),
  );

  // app.vueApp.component(
  //   'competition-leaderboard',
  //   defineAsyncComponent(
  //     () => import('@/components/shared'),
  //   ),
  // );

  app.vueApp.component(
    'hero-gamification-banner-slide',
    defineAsyncComponent(
      () => import('@/components/gamification/HeroGamificationBannerSlide.vue'),
    ),
  );
  app.vueApp.component(
    'challenge-card',
    defineAsyncComponent(
      () => import('@/components/gamification/challengeCard.vue'),
    ),
  );
  app.vueApp.component(
    'leaderboard-banner',
    defineAsyncComponent(
      () => import('@/components/gamification/LeaderboardBanner.vue'),
    ),
  );
  app.vueApp.component(
    'generic-challenges-list',
    defineAsyncComponent(
      () => import('@/components/gamification/GenericChallengesList.vue'),
    ),
  );
  app.vueApp.component(
    'profile-challenges-list',
    defineAsyncComponent(
      () => import('@/components/gamification/ProfileChallengesList.vue'),
    ),
  );
  app.vueApp.component(
    'shack-card',
    defineAsyncComponent(
      () => import('@/components/gamification/shackCard.vue'),
    ),
  );
  app.vueApp.component(
    'wow-video-banner',
    defineAsyncComponent(
      () => import('@/components/video/banners/WowVideoBanner.vue'),
    ),
  );
  app.vueApp.component(
    'wow-video-card',
    defineAsyncComponent(
      () => import('@/components/video/cards/WowVideoCard.vue'),
    ),
  );
  app.vueApp.component(
    'video-widget',
    defineAsyncComponent(
      () => import('@/components/video/players/VideoWidget.vue'),
    ),
  );
  app.vueApp.component(
    'ment-dialog',
    defineAsyncComponent(() => import('@/components/dialogs/mentdialog.vue')),
  );
  app.vueApp.component(
    'voucher-list',
    defineAsyncComponent(() => import('@/components/vouchers/VoucherList.vue')),
  );
  app.vueApp.component(
    'wow-setting-menu',
    defineAsyncComponent(
      () => import('@/components/header/WowSettingMenu.vue'),
    ),
  );
  app.vueApp.component(
    'wow-toggle-lang',
    defineAsyncComponent(() => import('@/components/header/WowToggleLang.vue')),
  );
  app.vueApp.component(
    'wow-toggle-theme',
    defineAsyncComponent(
      () => import('@/components/header/WowToggleTheme.vue'),
    ),
  );
  app.vueApp.component(
    'wow-music-track-thumbnail',
    defineAsyncComponent(
      () => import('@/components/music/cards/WowMusicTrackThumbnail.vue'),
    ),
  );
  app.vueApp.component(
    'loader',
    defineAsyncComponent(() => import('@/components/shared/Loader.vue')),
  );
  app.vueApp.component(
    'wow-music-video-card',
    defineAsyncComponent(
      () => import('@/components/music/cards/WowMusicVideoCard.vue'),
    ),
  );
  app.vueApp.component(
    'wow-hero-meta-data-artist',
    defineAsyncComponent(
      () => import('@/components/music/banners/WowHeroMetaDataArtist.vue'),
    ),
  );
  app.vueApp.component(
    'wow-hero-music-details',
    defineAsyncComponent(
      () => import('@/components/music/banners/WowHeroMusicDetails.vue'),
    ),
  );
  app.vueApp.component(
    'wow-music-track',
    defineAsyncComponent(
      () => import('@/components/music/cards/WowMusicTrack.vue'),
    ),
  );
  app.vueApp.component(
    'wow-music-video-details-banner',
    defineAsyncComponent(
      () => import('@/components/music/banners/WowMusicVideoDetailsBanner.vue'),
    ),
  );
  app.vueApp.component(
    'wow-playlist-card',
    defineAsyncComponent(
      () => import('@/components/music/cards/WowPlaylistCard.vue'),
    ),
  );
  app.vueApp.component(
    'user-ticket-card',
    defineAsyncComponent(() => import('@/components/cards/UserTicketCard.vue')),
  );
  app.vueApp.component(
    'wow-hero-music-banner',
    defineAsyncComponent(
      () => import('@/components/music/banners/WowHeroMusicBanner.vue'),
    ),
  );
  app.vueApp.component(
    'wow-genre-card',
    defineAsyncComponent(
      () => import('@/components/music/cards/WowGenreCard.vue'),
    ),
  );
  app.vueApp.component(
    'wow-hero-genre-banner',
    defineAsyncComponent(
      () => import('@/components/music/banners/WowHeroGenreBanner.vue'),
    ),
  );
  app.vueApp.component(
    'confirm-cancel-subscription',
    defineAsyncComponent(
      () => import('@/components/dialogs/ConfirmCancelSubscription.vue'),
    ),
  );
  app.vueApp.component(
    'generic-error-dialog',
    defineAsyncComponent(
      () => import('@/components/dialogs/GenericErrorDialog.vue'),
    ),
  );
  app.vueApp.component(
    'app-shortcut-installer',
    defineAsyncComponent(
      () => import('~/components/cards/AppShortcutInstaller.vue'),
    ),
  );
  app.vueApp.component(
    'purchase-dialog-v2',
    defineAsyncComponent(
      () => import('@/components/dialogs/purchaseDialogV2.vue'),
    ),
  );
  app.vueApp.component(
    'subscription-dialog-v2',
    defineAsyncComponent(
      () => import('@/components/dialogs/subscriptionDialogV2.vue'),
    ),
  );
  app.vueApp.component(
    'read-more',
    defineAsyncComponent(() => import('@/components/shared/ReadMore.vue')),
  );
  /// Keep Root End
  app.vueApp.component(
    'Root',
    defineAsyncComponent(() => import('@/components/shared/RootComponent.vue')),
  );
  app.vueApp.component(
    'subscription-plan-v2',
    defineAsyncComponent(
      () => import('@/components/subscriptions/SubscriptionPlanV2.vue'),
    ),
  );
  app.vueApp.component(
    'double-opt-in',
    defineAsyncComponent(
      () => import('@/components/subscriptions/doubleOptIn.vue'),
    ),
  );

  app.vueApp.component(
    'geo-block-info',
    defineAsyncComponent(
      () => import('@/components/geo-block/geoBlockInfo.vue'),
    ),
  );
  app.vueApp.component(
    'non-supported-device-disclaimer',
    defineAsyncComponent(
      () => import('@/components/dialogs/NonSupportedDeviceDisclaimer.vue'),
    ),
  );
  app.vueApp.component(
    'switch-link-element',
    defineAsyncComponent(
      () => import('@/components/shared/SwitchLinkElement.vue'),
    ),
  );
  app.vueApp.component(
    'Tooltip',
    defineAsyncComponent(() => import('@/components/shared/Tooltip.vue')),
  );
  app.vueApp.component(
    'card-container',
    defineAsyncComponent(() => import('@/components/shared/CardContainer.vue')),
  );

  app.vueApp.component(
    'monsooq-trending-card',
    defineAsyncComponent(
      () => import('@/components/monsooq/cards/MonsooqTrendingCard.vue'),
    ),
  );
  app.vueApp.component(
    'monsooq-quick-access-card',
    defineAsyncComponent(
      () => import('@/components/monsooq/cards/MonsooqQuickAccessCard.vue'),
    ),
  );
  app.vueApp.component(
    'monsooq-horizontal-access-card',
    defineAsyncComponent(
      () =>
        import('@/components/monsooq/cards/MonsooqHorizontalAccessCard.vue'),
    ),
  );
  app.vueApp.component(
    'non-partner-card',
    defineAsyncComponent(() => import('@/components/cards/NonPartnerCard.vue')),
  );

  app.vueApp.component(
    'monsooq-apps-card',
    defineAsyncComponent(
      () => import('@/components/monsooq/cards/MonsooqAppsCard.vue'),
    ),
  );
  app.vueApp.component(
    'game-recently-played',
    defineAsyncComponent(
      () => import('@/components/monsooq/cards/GameRecentlyPlayed.vue'),
    ),
  );
  app.vueApp.component(
    'monsooq-my-apps-card',
    defineAsyncComponent(
      () => import('@/components/monsooq/cards/MonsooqMyAppsCard.vue'),
    ),
  );
  app.vueApp.component(
    'monsooq-hero-game-card',
    defineAsyncComponent(
      () => import('@/components/shared/MonsooqHeroGameCard/HeroGameCard.vue'),
    ),
  );
  app.vueApp.component(
    'monsooq-vertical-game-card',
    defineAsyncComponent(
      () => import('@/components/shared/MonsooqVerticalGameCard.vue'),
    ),
  );
  app.vueApp.component(
    'carousel-monsooq',
    defineAsyncComponent(
      () => import('@/components/shared/CarouselMonsooq.vue'),
    ),
  );
  app.vueApp.component(
    'non-partner-carousel',
    defineAsyncComponent(
      () => import('@/components/shared/NonPartnerCarousel.vue'),
    ),
  );

  app.vueApp.component(
    'monsooq-sub-card',
    defineAsyncComponent(
      () => import('@/components/monsooq/cards/MonsooqSubCard.vue'),
    ),
  );

  app.vueApp.component(
    'monsooq-launch-card',
    defineAsyncComponent(() => import('../components/cards/LaunchCard.vue')),
  );

  app.vueApp.component(
    'monsooq-consent-management',
    defineAsyncComponent(
      () => import('@/components/monsooq/sections/ConsentManagement.vue'),
    ),
  );
  app.vueApp.component(
    'partner-subscription-manager',
    defineAsyncComponent(
      () => import('@/components/cards/PartnerSubscriptionManager.vue'),
    ),
  );
  app.vueApp.component(
    'monsooq-register',
    defineAsyncComponent(() => import('~/components/cards/SignUp.vue')),
  );
  app.vueApp.component(
    'LoginOrSignUp',
    defineAsyncComponent(() => import('~/components/cards/LoginOrSignUp.vue')),
  );
  app.vueApp.component(
    'SuccessDialog',
    defineAsyncComponent(() => import('@/components/dialogs/SuccessDialog.vue')),
  );
  app.vueApp.component(
    'LoginOrSignUpDialog',
    defineAsyncComponent(
      () => import('@/components/dialogs/LoginOrSignUpDialog.vue'),
    ),
  );

  app.vueApp.component(
    'monsooq-profile-setting-card',
    defineAsyncComponent(
      () => import('@/components/cards/ProfileSettingCard.vue'),
    ),
  );

  app.vueApp.component(
    'setting-option',
    defineAsyncComponent(() => import('@/components/cards/SettingOption.vue')),
  );
  app.vueApp.component(
    'partner-banner',
    defineAsyncComponent(() => import('~/components/cards/PartnerSection.vue'),
      
    ),
  );
  app.vueApp.component(
    'partner-subscription-card',
    defineAsyncComponent(
      () => import('@/components/cards/PartnerSubscriptionCard.vue'),
    ),
  );
  app.vueApp.component(
    'grid-layout',
    defineAsyncComponent(() => import('@/components/shared/grid-layout.vue')),
  );
  app.vueApp.component(
    'container-box',
    defineAsyncComponent(() => import('@/components/shared/ContainerBox.vue')),
  );
  app.vueApp.component(
    'appbar-logged-user',
    defineAsyncComponent(
      () => import('@/components/shared/AppbarLoggedUser.vue'),
    ),
  );
  app.vueApp.component(
    'partner-bullets',
    defineAsyncComponent(() => import('@/components/cards/PartnerBullets.vue')),
  );

  app.vueApp.component(
    'edit-user',
    defineAsyncComponent(() => import('@/components/dialogs/EditUser.vue')),
  );
  app.vueApp.component(
    'payment-section',
    defineAsyncComponent(
      () => import('@/components/monsooq/sections/PaymentSection.vue'),
    ),
  );
  app.vueApp.component(
    'mobile-side-sections',
    defineAsyncComponent(
      () => import('@/components/monsooq/sections/MobileSideSections.vue'),
    ),
  );
  app.vueApp.component(
    'partner-subscription-custom-plan',
    defineAsyncComponent(
      () =>
        import('@/components/subscriptions/PartnerSubscriptionCustomPlan.vue'),
    ),
  );
  app.vueApp.component(
    'PartnerSubscribtionCustomDialog',
    defineAsyncComponent(
      () => import('@/components/dialogs/PartnerSubscriptionCustomDialog.vue'),
    ),
  );
  app.vueApp.component(
    'feature-section',
    defineAsyncComponent(
      () => import('@/components/shared/FeatureSection.vue'),
    ),
  );
  app.vueApp.component(
    'feature-cards',
    defineAsyncComponent(() => import('@/components/cards/FeatureCards.vue')),
  );
  app.vueApp.component(
    'game-competition-card',
    defineAsyncComponent(
      () => import('@/components/cards/GameCompetitionCard.vue'),
    ),
  );
  app.vueApp.component(
    'GameCompetitionSection',
    defineAsyncComponent(
      () => import('@/components/cards/GameCompetitionSection.vue'),
    ),
  );
  app.vueApp.component(
    'leaderboard-card',
    defineAsyncComponent(
      () => import('@/components/cards/LeaderboardCard.vue'),
    ),
  );
  app.vueApp.component(
    'arcade-hero-game-details-banner',
    defineAsyncComponent(
      () => import('@/components/shared/ArcadeHeroGameDetailsBanner.vue'),
    ),
  );
  app.vueApp.component(
    'arcade-profile-options',
    defineAsyncComponent(
      () => import('@/components/profile/ArcadeProfileOptions.vue'),
    ),
  );
  app.vueApp.component(
    'arcade-reward',
    defineAsyncComponent(() => import('@/components/shared/ArcadeReward.vue')),
  );
  app.vueApp.component(
    'info-banner',
    defineAsyncComponent(() => import('@/components/shared/infoBanner.vue')),
  );
  app.vueApp.component(
    'badge-container',
    defineAsyncComponent(() => import('@/components/cards/BadgeContainer.vue')),
  );
  app.vueApp.component(
    'game-frame-dialog',
    defineAsyncComponent(() => import('../components/shared/GameIframe.vue')),
  );

  app.vueApp.component(
    'partner-header-v2',
    defineAsyncComponent(
      () => import('@/components/shared/PartnerHeaderV2.vue'),
    ),
  );
  app.vueApp.component(
    'weather-widget',
    defineAsyncComponent(() => import('@/components/weather-widget/index.vue')),
  );
  app.vueApp.component(
    'header-hero-content',
    defineAsyncComponent(() => import('@/components/shared/HeaderContent.vue')),
  );
  app.vueApp.component(
    'header-cta',
    defineAsyncComponent(() => import('@/components/shared/HeaderCta.vue')),
  );
  app.vueApp.component(
    'login-options-selection-dialog',
    defineAsyncComponent(
      () => import('@/components/dialogs/LoginOptionsSelectionDialog.vue'),
    ),
  );
  app.vueApp.component(
    'game-html-iframe-dialog',
    defineAsyncComponent(
      () => import('@/components/dialogs/GameHtmlIframeDialog.vue'),
    ),
  );
  app.vueApp.component(
    'terms-and-cond',
    defineAsyncComponent(() => import('@/components/shared/TermsAndCond.vue')),
  );
  app.vueApp.component(
    'competition-user-onboarding-pop',
    defineAsyncComponent(
      () => import('@/components/dialogs/CompetitionUserOnboardingPop.vue'),
    ),
  );

  app.vueApp.component(
    'avatar-list-pop',
    defineAsyncComponent(
      () => import('@/components/dialogs/CompetitionUserOnboardingPop.vue'),
    ),
  );
  app.vueApp.component(
    'icon-strip',
    defineAsyncComponent(() => import('@/components/shared/IconStrip.vue')),
  );
  app.vueApp.component(
    'terms-content-section',
    defineAsyncComponent(
      () => import('@/components/shared/TermsContentSection.vue'),
    ),
  );
  app.vueApp.component(
    'terms-card',
    defineAsyncComponent(() => import('@/components/cards/TermsCard.vue')),
  );
  app.vueApp.component(
    'currency-price',
    defineAsyncComponent(() => import('@/components/shared/CurrencyPrice.vue')),
  );
  app.vueApp.component(
    'partners-market-card',
    defineAsyncComponent(
      () => import('@/components/cards/PartnersMarketCard.vue'),
    ),
  );
  app.vueApp.component(
    'grid-steps-section',
    defineAsyncComponent(
      () => import('@/components/shared/GridStepsSection.vue'),
    ),
  );
  app.vueApp.component(
    'partner-benefits-section',
    defineAsyncComponent(
      () => import('@/components/shared/PartnerBenefitsSection.vue'),
    ),
  );
  app.vueApp.component(
    'partners-category-item',
    defineAsyncComponent(
      () => import('@/components/shared/PartnersCategoryItem.vue'),
    ),
  );
  app.vueApp.component(
    'adaptive-background-wrapper',
    defineAsyncComponent(
      () => import('@/components/shared/AdaptiveBackgroundWrapper.vue'),
    ),
  );
  app.vueApp.component(
    'partner-img',
    defineAsyncComponent(() => import('@/components/shared/PartnerImg.vue')),
  );
  app.vueApp.component(
    'app-benefit-2',
    defineAsyncComponent(() => import('@/components/shared/AppBenefit2.vue')),
  );
  app.vueApp.component(
    'app-benefit-3',
    defineAsyncComponent(() => import('@/components/shared/AppBenefit3.vue')),
  );
  app.vueApp.component(
    'game-genre-card',
    defineAsyncComponent(() => import('@/components/game/GenreCard.vue')),
  );
  app.vueApp.component(
    'external-logout',
    defineAsyncComponent(
      () => import('@/components/shared/ExternalLogout.vue'),
    ),
  );
  app.vueApp.component(
    'popup-app-installer',
    defineAsyncComponent(
      () => import('@/components/dialogs/PopupAppInstaller.vue'),
    ),
  );
  app.vueApp.component(
    'popup-iframe-game-actions',
    defineAsyncComponent(
      () => import('@/components/dialogs/PopupIframeGameActions.vue'),
    ),
  );
  app.vueApp.component(
    'confirm-cancel-pop-up-v2',
    defineAsyncComponent(
      () => import('@/components/dialogs/ConfirmCancelPopV2.vue'),
    ),
  );
  app.vueApp.component(
    'confirm-subscribe-pop-up-v2',
    defineAsyncComponent(
      () => import('@/components/dialogs/ConfirmSubscribePopV2.vue'),
    ),
  );
  app.vueApp.component(
    'materna-dialog',
    defineAsyncComponent(
      () => import('@/components/dialogs/MaternaDialog.vue'),
    ),
  );
  app.vueApp.component(
    'custom-feedback-dialog',
    defineAsyncComponent(
      () => import('@/components/dialogs/CustomFeedbackDialog.vue'),
    ),
  );
  app.vueApp.component(
    'hero-news-banner-slide',
    defineAsyncComponent(
      () => import('@/components/shared/HeroNewsBannerSlide.vue'),
    ),
  );
  app.vueApp.component(
    'CreditCardPaymentOptions',
    defineAsyncComponent(
      () => import('@/components/dialogs/CreditCardPaymentOptions.vue'),
    ),
  );
  app.vueApp.component(
    'page-heading-text',
    defineAsyncComponent(
      () => import('@/components/shared/PageHeadingText.vue'),
    ),
  );
  app.vueApp.component(
    'external-scripts',
    defineAsyncComponent(
      () => import('@/components/shared/ExternalScripts.vue'),
    ),
  );
  app.vueApp.component(
    'tabs-navigation',
    defineAsyncComponent(
      () => import('@/components/shared/TabsNavigation.vue'),
    ),
  );
  app.vueApp.component(
    'account-info-view',
    defineAsyncComponent(
      () => import('@/components/profile/AccountInfoView.vue'),
    ),
  );
  app.vueApp.component(
    'confirm-profile-delete',
    defineAsyncComponent(
      () => import('@/components/dialogs/ConfirmProfileDelete.vue'),
    ),
  );
  app.vueApp.component(
    'cancel-subscription-confirmation',
    defineAsyncComponent(
      () => import('@/components/dialogs/CancelSubscriptionConfirmation.vue'),
    ),
  );
  app.vueApp.component(
    'game-control-bar',
    defineAsyncComponent(() => import('@/components/game/GameControlBar.vue')),
  );
  app.vueApp.component(
    'game-play-details-with-controls',
    defineAsyncComponent(
      () => import('@/components/game/HeroGamePlayDetailsWithControls.vue'),
    ),
  );
  app.vueApp.component(
    'retrofun-card',
    defineAsyncComponent(() => import('@/components/cards/RetroFunCard.vue')),
  );
  app.vueApp.component(
    'versatile-banner',
    defineAsyncComponent(
      () => import('@/components/cards/VersatileBanner.vue'),
    ),
  );
  app.vueApp.component(
    'partner-subscription-details-section',
    defineAsyncComponent(
      () =>
        import(
          '@/components/monsooq/sections/PartnerSubscriptionDetailsSection.vue'
        ),
    ),
  );
  app.vueApp.component(
    'partner-sub-card',
    defineAsyncComponent(
      () => import('@/components/monsooq/cards/PartnerSubCard.vue'),
    ),
  );
  app.vueApp.component(
    'partner-subscription-list-container',
    defineAsyncComponent(
      () => import('@/components/shared/PartnerSubscriptionListContainer.vue'),
    ),
  );
  app.vueApp.component(
    'profile-fields',
    defineAsyncComponent(
      () => import('@/components/shared/ProfileFields.vue'),
    ),
  );
  app.vueApp.component(
    'promo-hero-banner',
    defineAsyncComponent(
      () => import('@/components/cards/PromoHeroBanner.vue'),
    ),
  );
});
